<h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.MODALGEN.URL_QR.TITULO' | translate}}</h2>
<mat-dialog-content class="mat-typography">
  <p><em>{{'SHEDULE2_0.CARDS.MODALGEN.URL_QR.SUBTITULO' | translate}}</em></p>
  <div fxLayout="column" fxLayoutAlign="center stretch" class="mt-20 mb-20">
    <div fxLayout="row" fxLayoutAlign="center">
      <img [src]="datos.urlQR" alt="" fxFlex="30">
    </div>
    <br>
    <h3 [innerHTML]="'SHEDULE2_0.CARDS.MODALGEN.URL_QR.DESCARGA' | translate"></h3>
  </div>
  <!-- <p><em>También puede realizar las siguientes acciones</em></p>
  <div fxLayout="row" fxLayoutAlign="space-evenly center">
    <a [href]="datos.urlQR" target="_blank" download="QRCode.png">
      <button mat-raised-button color="primary">
        Descargar como imagen
        <mat-icon class="ml-20">image</mat-icon>
      </button>
    </a>
    <button mat-raised-button color="primary">
      Descargar como PDF
      <mat-icon class="ml-20">picture_as_pdf</mat-icon>
    </button>
  </div> -->
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
    {{'SHEDULE2_0.BACK' | translate}}
    <mat-icon class="ml-20">arrow_back</mat-icon>
  </button>
</div>
